<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      progress: 5,
      speed: 1,
      loop: null,
    };
  },

  computed: {
    ...mapGetters(["getTourCategoryTitle"]),
  },

  methods: {
    frame() {
      if (this.progress < 100) {
        this.progress = this.progress + this.speed;
      }
    },
  },

  mounted() {
    this.loop = setInterval(this.frame, 1000);
  },

  beforeDestroy() {
    if (this.loop) {
      clearInterval(this.loop);
    }
  },
};
</script>

<template>
  <div class="c-loading my--4">
    <div class="loading">
      <div class="loading__wrapper">
        <div class="loading__title">
          <span>
            در حال جستجو هستیم
          </span>
        </div>

        <div class="loading__progress">
          <div class="loading__progress-filler" :style="`width:${progress}%;`"></div>
        </div>

        <div class="loading__cover" />
      </div>
    </div>
  </div>
</template>
